import { useGeneratePDF } from 'common/queries-and-mutations/user';
import React from 'react';

export default function PDF() {
  const { data } = useGeneratePDF();

  return (
    <div>
      <div className="h-full w-full">
        <iframe
          className="h-[1000px] w-full"
          src={`data:application/pdf;base64,${data}`}
        ></iframe>
      </div>
    </div>
  );
}
